import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DropdownHttpService } from '@core/services/dropdown-http.service';
import { Subscription } from 'rxjs';
import { EventEmitterService } from '@core/services/event-emitter.service';

@Component({
  selector: 'kt-promotion',
  templateUrl: './kyc-setting.component.html',
  styleUrls: ['./kyc-setting.component.scss']
})
export class KycSettingComponent implements OnInit {
  selectedOption: string = 'none';

  dropdown = {
    kycStatuses: this.dropdownHttpService.kyc_statuses,
    kycOptions: this.dropdownHttpService.kyc_options
  };
  kycOptionDropdownSettings = {};
  kycOptionSelectedItem = [];
  kycStatusDropdownSettings = {};
  kycStatusSelectedItem = [];
  form: FormGroup;

  private formSubscription: Subscription;
  private saveSubscription: Subscription;

  constructor(
    private dropdownHttpService: DropdownHttpService,
    private eventEmitterService: EventEmitterService,
    @Optional() @Inject('initialData') private initialData: any,
    @Optional() @Inject('isEditMode') public isEditMode: boolean
  ) {
    this.initialData = initialData;
  }

  ngOnInit() {
    this.formInit();
    this.emitFormData();

    this.formSubscription = this.form.valueChanges.subscribe(values => {
      this.emitFormData(values);
    });

    this.kycStatusDropdownSettings = {
      singleSelection: false,
      text: 'Please Select',
      enableFilterSelectAll: false,
      enableSearchFilter: false,
      classes: 'dropdown',
      maxHeight: 200,
      primaryKey: 'id',
      labelKey: 'name',
      noDataLabel: '',
      showCheckbox: false
    };
    this.kycOptionDropdownSettings = {
      singleSelection: false,
      text: 'Please Select',
      enableFilterSelectAll: false,
      enableSearchFilter: false,
      classes: 'dropdown',
      maxHeight: 200,
      primaryKey: 'id',
      labelKey: 'name',
      noDataLabel: '',
      showCheckbox: false
    };
  }

  onSelect(option: string): void {
    this.selectedOption = option;

    if (option === 'manual') {
      this.form.patchValue({ kyc_option: this.form.value.kyc_option }, { emitEvent: false });
      this.kycOptionSelectedItem = this.dropdown.kycOptions.filter(opt =>
        Array.isArray(this.form.value.kyc_option) ? this.form.value.kyc_option.includes(opt.id) : this.form.value.kyc_option === opt.id
      );
      this.form.patchValue({ kyc_status: null }, { emitEvent: false });
      this.kycStatusSelectedItem = [];
    } else if (option === 'kyc-status') {
      this.form.patchValue({ kyc_status: this.form.value.kyc_status }, { emitEvent: false });
      this.kycStatusSelectedItem = this.dropdown.kycStatuses.filter(st =>
        Array.isArray(this.form.value.kyc_status) ? this.form.value.kyc_status.includes(st.id) : this.form.value.kyc_status === st.id
      );
      this.form.patchValue({ kyc_option: null }, { emitEvent: false });
      this.kycOptionSelectedItem = [];
    } else {
      this.form.patchValue({ kyc_status: null, kyc_option: null }, { emitEvent: false });
      this.kycStatusSelectedItem = [];
      this.kycOptionSelectedItem = [];
    }

    this.updateValidators();
    this.emitFormData();
  }

  ngOnDestroy() {
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
    if (this.saveSubscription) {
      this.saveSubscription.unsubscribe();
    }
  }

  private formInit() {
    let kyc_status = this.initialData?.kyc_status || null;
    let kyc_option = this.initialData?.kyc_option || null;
    this.form = new FormGroup({
      kyc_status: new FormControl(kyc_status),
      kyc_option: new FormControl(kyc_option),
    });

    if (kyc_option && kyc_option.length > 0) {
      this.selectedOption = 'manual';
      this.kycOptionSelectedItem = this.dropdown.kycOptions.filter(opt =>
        Array.isArray(kyc_option) ? kyc_option.includes(opt.id) : kyc_option === opt.id
      );
    } else if (kyc_status && kyc_status.length > 0) {
      this.selectedOption = 'kyc-status';
      this.kycStatusSelectedItem = this.dropdown.kycStatuses.filter(st =>
        Array.isArray(kyc_status) ? kyc_status.includes(st.id) : kyc_status === st.id
      );
    } else {
      this.selectedOption = 'none';
      this.kycOptionSelectedItem = [];
      this.kycStatusSelectedItem = [];
    }
    this.updateValidators();
  }

  private updateValidators() {
    const kycStatusControl = this.form.get('kyc_status');
    const kycOptionControl = this.form.get('kyc_option');
    if (this.selectedOption === 'manual') {
      kycOptionControl?.setValidators([Validators.required]);
      kycStatusControl?.clearValidators();
    } else if (this.selectedOption === 'kyc-status') {
      kycStatusControl?.setValidators([Validators.required]);
      kycOptionControl?.clearValidators();
    } else {
      kycStatusControl?.clearValidators();
      kycOptionControl?.clearValidators();
    }

    kycStatusControl?.updateValueAndValidity({ emitEvent: false });
    kycOptionControl?.updateValueAndValidity({ emitEvent: false });
  }

  private emitFormData(values: any = this.form.value) {
    this.eventEmitterService.onKYCSettingData({
      ...values,
      selectedOption: this.selectedOption
    });
  }
}